import { render, staticRenderFns } from "./studentAdministrator.vue?vue&type=template&id=668003c2"
import script from "./studentAdministrator.vue?vue&type=script&lang=js"
export * from "./studentAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports